import { render } from "./ConsegnaMerce.vue?vue&type=template&id=14f03846&scoped=true"
import script from "./ConsegnaMerce.vue?vue&type=script&lang=js"
export * from "./ConsegnaMerce.vue?vue&type=script&lang=js"

import "./ConsegnaMerce.vue?vue&type=style&index=0&id=14f03846&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f03846"]])

export default __exports__